import { Component, OnInit, Input, ViewChild, SimpleChanges, Output, EventEmitter, Renderer2, ElementRef } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { MatPaginator, MatTableDataSource, MatSort, MatSnackBar } from '@angular/material';
import { FieldDescriptor, controlTypes } from '@utilities/SpecialForms';
import { ExportFacadeService } from '../../core/services/control/exporter-facade.service';
import { spanish } from '../../core/internationalization/i18n.es';
import { isNullOrUndefined } from 'util';

interface DataField {
  [columna: string]: string;
}

@Pipe({ name: 'orderTableColumns' })
export class orderTableColumns implements PipeTransform {
  transform(data: FieldDescriptor[]): any {
    return data.map(item => item.name);
  }
}

@Pipe({ name: 'getCellData' })
export class getCellDataPipe implements PipeTransform {
  transform(data: Object, fieldData: FieldDescriptor): any {
    switch (fieldData.type) {
      case controlTypes.pkey: return data[fieldData.name];
      case controlTypes.text: return data[fieldData.name];
      case controlTypes.dropdown: return data[fieldData.name]/* [fieldData.data[0]] */;
      case controlTypes.autocomplete: return data[fieldData.name]/* [fieldData.data[1]] */;
      case controlTypes.longText: return data[fieldData.name];
      case controlTypes.chips: return data[fieldData.name];
      case controlTypes.boolean: return data[fieldData.name] ? fieldData.data[0] : fieldData.data[1];
      case controlTypes.actions: return fieldData.data.join();
    }
  }
}

@Component({
  selector: 'list-table',
  templateUrl: './list-table.component.html',
  styleUrls: ['./list-table.component.scss'],
})
export class ListTableComponent implements OnInit {
  @Input() data: any[];
  @Input() structure: FieldDescriptor[];
  @Input() pageSize: number = 50;
  @Input('table') partitionKey: string = "";
  @Input('nameExcel') nameExcel: string;
  @Output() editItem: EventEmitter<any> = new EventEmitter();
  @Output() action: EventEmitter<any> = new EventEmitter();
  @Output() optionSelected: EventEmitter<object> = new EventEmitter();
  @Output() hyperLink: EventEmitter<string> = new EventEmitter();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  controlTypes = controlTypes;
  dataSource: MatTableDataSource<any>;

  public dataExport: any[];
  private _dataExport: any[];

  private objData: DataField;
  private inputFilterReference: ElementRef[] = [];

  constructor(
    private exportFacadeService: ExportFacadeService,
    private _snackBar: MatSnackBar,
    private _renderer2: Renderer2
  ) { }

  ngOnInit() {
    this.dataExport = this.dataSource.data;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.data && changes.data.currentValue) {
      this.dataMapping(this.data);
    }
  }


  clickedItem(item) {
    for (const iterator of this.inputFilterReference) {
      this._renderer2.setProperty(iterator.nativeElement, 'value', '');
    }
    this.inputFilterReference = [];
    this.editItem.emit(item);
  }

  applyFilter(filterValue: string, columna: string, entrada: any): void {

    // AGREGA CADA ELEMENTO DE ENTRADA DEL FIILTRO AL ARREGLO DE INPUTREFERENCIE
    if (this.inputFilterReference.length === 0) {
      this.inputFilterReference.push(new ElementRef(entrada));
    } else {
      for (const input of this.inputFilterReference) {
        if (input.nativeElement.id !== entrada.id) {
          this.inputFilterReference.push(new ElementRef(entrada));
        }
      }
    }

    this.objData = { ...this.objData, ...{ [columna]: filterValue.toLowerCase().trim() } };

    let rawData = [...this.data];
    for (const key in this.objData) {
      if (this.objData.hasOwnProperty(key)) {
        const value = this.objData[key];
        const filtro = rawData.filter(i => {
          if (isNullOrUndefined(i[key])) {
            return false;
          }
          //console.log(i[key])
          const element = (<string>(i[key])).toLowerCase();
          if (element.includes(value)) {
            return true;
          } else {
            return false;
          }
        });
        rawData = [...filtro];
      }
      this.dataMapping(rawData);
    }
    //this.dataExport = rawData;
  }

  private dataMapping(data: any[]): void {

    this.dataSource = new MatTableDataSource<any>(data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.dataExport = [...data]; // Datos para tabla de exportación a Excel

    this.dataSource.sortData = (data, sort) => {
      const column = sort.active;
      const direction = sort.direction;
      data.sort((a, b) => this.sortList(a[column], b[column], direction));
      this.dataExport = [...data]; // Datos para tabla de exportación a Excel
      return data;

    };

  }

  private sortList(a: string | number, b: string | number, direccion: string = 'asc') {

    const a1 = typeof a === 'number' ? +a : a;
    const b1 = typeof a === 'number' ? +b : b;

    if (direccion === 'asc') {
      if (a1 > b1) {
        return 1;
      }
      if (a1 < b1) {
        return -1;
      }
    } else {
      if (a1 > b1) {
        return -1;
      }
      if (a1 < b1) {
        return 1;
      }
    }
    return 0;
  }

  exportToExcel() {

    if (this.dataExport.length <= 0) {
      this._snackBar.open("Para exportar a Excel debe existir al menos 1 registro en la tabla.", "", { duration: 5000, });
    } else {
      this.dataExport = this.sortColumns(this.dataExport);
      var dataToExport = this.getFormattedData(Object.keys(this.dataExport[0]));
      this.exportFacadeService.exportToExcel(dataToExport, this.nameExcel);
    }
  }

  private getFormattedData(keyList: any[]): any[] {
    var dataList: any[] = [];
    var objectConstructor = ({}).constructor;
    this.dataExport.forEach(json => {
      var jsonData = {};
      keyList.forEach(k => {
        if (k !== "label") {
          var key = this.getTranslateText(k);
          if (key !== "") {
            var value = json[k];
            if (value !== null && value.constructor === objectConstructor) {
              var obj = json[k];
              var levelTwoArray = Object.keys(obj).map(function (i) {
                if (obj[i].constructor === objectConstructor) {
                  return '';
                } else {
                  return obj[i];
                }
              });
              value = levelTwoArray.map(x => x).join(", ");
            }
            jsonData[key] = value;
          }
        }
      });
      dataList.push(jsonData);
    });
    return dataList;
  }

  private getTranslateText(key: string): string {
    let lblEs = "";
    Object.keys(spanish).forEach(label => {
      if (label === key) {
        lblEs = spanish[key];
      }
    });
    return lblEs;
  }

  /**
   * Ordena los campos segun el orden de la tabla a nivel visual antes de exportar a excel
   * @param list
   * @returns {any[]}
   */
  private sortColumns(list: any[]): any[] {
    const orderingStructure = [];
    for (const iterator of this.structure) {
      if (iterator.name !== 'Button') {
        const element = { column: iterator.name, order: iterator.order };
        orderingStructure.push(element);
      }
    }

    const result: any[] = [];
    for (const row of list) {
      let orderedRow: DataField = {};
      for (const iterator of orderingStructure) {
        orderedRow = {
          ...orderedRow,
          ...{ [iterator['column']]: row[iterator['column']] },
        };
      }
      result.push(orderedRow);
    }
    return [...result];
  }

}


